import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { BackLink } from "@/components/BackLink";
import { PermissionGate } from "@/components/PermissionGate";
import { CampaignDetail } from "@/modules/campaigns";


export default function CampaignDetailPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("nav.campaigns")}
    >
      <BackLink fallback="/campaigns" className="text-sm text-nb-text-2 hover:underline">
        ← {t("common.back")}
      </BackLink>
      <PermissionGate perm="campaign.read">
        <CampaignDetail />
      </PermissionGate>
    </AppLayout>
  );
}
